import { UserAccessType } from '@types';

import { useProfile } from '../use-profile/use-profile.hook';

export function useCheckAccesses() {
  const profile = useProfile();

  const userIs = (accessType: UserAccessType) => {
    return profile?.accessType === accessType;
  };

  const userIsNot = (accessType: UserAccessType) => {
    if (!profile) return true;
    return profile?.accessType !== accessType;
  };

  const userIsOneOf = (accessTypes: UserAccessType[]) => {
    return profile ? accessTypes.includes(profile.accessType) : false;
  };

  const userIsNotOneOf = (accessTypes: UserAccessType[]) => {
    if (!profile) return true;
    return !accessTypes.includes(profile.accessType);
  };

  return {
    userIs,
    userIsNot,
    userIsOneOf,
    userIsNotOneOf,
  };
}
